// Studyo Today Backend
// Package studyo.today.item_duplication.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/item_duplication/v1/resources/item_distribution_pattern_kind.proto (package studyo.today.item_duplication.v1.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/item_duplication/v1/resources/item_distribution_pattern_kind.proto.
 */
export const file_studyo_today_item_duplication_v1_resources_item_distribution_pattern_kind = /*@__PURE__*/
  fileDesc("Ck9zdHVkeW8vdG9kYXkvaXRlbV9kdXBsaWNhdGlvbi92MS9yZXNvdXJjZXMvaXRlbV9kaXN0cmlidXRpb25fcGF0dGVybl9raW5kLnByb3RvEipzdHVkeW8udG9kYXkuaXRlbV9kdXBsaWNhdGlvbi52MS5yZXNvdXJjZXMq3AEKG0l0ZW1EaXN0cmlidXRpb25QYXR0ZXJuS2luZBIuCipJVEVNX0RJU1RSSUJVVElPTl9QQVRURVJOX0tJTkRfVU5TUEVDSUZJRUQQABIyCi5JVEVNX0RJU1RSSUJVVElPTl9QQVRURVJOX0tJTkRfU0FNRV9PQ0NVUlJFTkNFEAESKwonSVRFTV9ESVNUUklCVVRJT05fUEFUVEVSTl9LSU5EX1NBTUVfREFZEAISLAooSVRFTV9ESVNUUklCVVRJT05fUEFUVEVSTl9LSU5EX1NBTUVfVElNRRADQjGqAi5TdHVkeW8uVG9kYXkuSXRlbUR1cGxpY2F0aW9uLkdycGMuVjEuUmVzb3VyY2VzYgZwcm90bzM");

/**
 * Describes the enum studyo.today.item_duplication.v1.resources.ItemDistributionPatternKind.
 */
export const ItemDistributionPatternKindSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_item_duplication_v1_resources_item_distribution_pattern_kind, 0);

/**
 * All possible patterns used to determine to due date of distributed items.
 *
 * @generated from enum studyo.today.item_duplication.v1.resources.ItemDistributionPatternKind
 */
export const ItemDistributionPatternKind = /*@__PURE__*/
  tsEnum(ItemDistributionPatternKindSchema);

